<template>
  <div class="c-app" v-if="!loading">

    <EventManagerSidebar @createGallery="openCreateGallery"/>
    <CWrapper>
      <TheHeader/>
      <Notifier/>
      <CreateNewGalleryModal ref="createNewGalleryModal"/>
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <router-view></router-view>
          </CContainer>
        </main>
      </div>
    </CWrapper>
  </div>
</template>

<script>
import TheHeader from '../../containers/TheHeader.vue'
import Notifier from "../../components/Notifier.vue"
import {mapActions, mapGetters} from "vuex";
import EventManagerSidebar from "@/domain/eventManage/EventManagerSidebar.vue";
import MessageManager from "@/domain/core/utils/messageManager";
import CreateNewGalleryModal from "@/domain/eventGallery/components/CreateNewGalleryModal.vue";


export default {
  name: 'EventManager',
  components: {
    CreateNewGalleryModal,
    EventManagerSidebar,
    TheHeader,
    Notifier,
  },

  data() {
    return {
      loading: true,
      picaServiceId: null,
    }
  },

  async beforeMount() {
    this.setEventId(this.$route.params.picaServiceId)
    await this.logoSet_setPicaServiceId(this.$route.params.picaServiceId)
    await this.picaCode_setPicaServiceId(this.$route.params.picaServiceId)
    await this.stats_setPicaServiceId(this.$route.params.picaServiceId)
    await this.gallery_setPicaServiceId(this.$route.params.picaServiceId)

    MessageManager.setUserId(this.user?.id)
    MessageManager.setPicaService(this.$route.params.picaServiceId)

    await Promise.all([
      this.fetchPicaService(this.$route.params.picaServiceId),
      this.fetchEventConfiguration(),
      this.fetchConfig({
        type: 'pica_service',
        id: this.$route.params.picaServiceId
      })
    ])
    await this.fetchFormData()
    this.loading = false
  },
  mounted() {
     this.picaServiceId = this.$route.params.picaServiceId
  },
  beforeDestroy() {
    MessageManager.setPicaService(null)
  },
  computed: {
    ...mapGetters('event', [
      'isUserStatsViewer',
    ]),
    ...mapGetters('login', [
      'user',
    ]),
  },
  methods: {
    ...mapActions('event', [
      'fetchPicaService',
    ]),
    ...mapActions('login', [
      'fetchConfig',
    ]),
    ...mapActions('eventWizard', [
      'setEventId',
      'fetchEventConfiguration',
      'fetchFormData',
      'setStepAsActive',
    ]),
    ...mapActions('logoSet', {
      logoSet_setPicaServiceId: 'setPicaServiceId'
    }),
    ...mapActions('picaCode', {
      picaCode_setPicaServiceId: 'setPicaServiceId'
    }),
    ...mapActions('nStats', {
      stats_setPicaServiceId: 'setPicaServiceId',
    }),
    ...mapActions('eventGallery', {
      gallery_setPicaServiceId: 'setPicaServiceId'
    }),
    openCreateGallery(params) {
      if (!params) params = {}
      this.$refs.createNewGalleryModal.open(params)
    },
  }
}
</script>
